// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Double_wrap__k1_b4","article":"Double_article__taLmc","skeleton":"Double_skeleton__PO442"};